module.exports = __webpack_public_path__ + "static/img/banner-1.83e7952c.png";